import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { GameProvider } from "@/game/GameContext";
import GameRoot from "@/screens/GameRoot";
import AdminLogin from "@/screens/AdminLogin";
import AdminDashboard from "@/screens/AdminDashboard";

export default function App() {
  return (
    <div className="App">
      <div className="crt-scanlines" aria-hidden="true" />
      <BrowserRouter>
        <GameProvider>
          <Routes>
            <Route path="/" element={<GameRoot />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </GameProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}
